<template>
    <ProgressSpinner 
        :style="{'width': '50px','height': '50px'}"
        strokeWidth="8" 
        :fill="fillColor" 
        animationDuration=".9s"
        aria-label="Custom ProgressSpinner"
        :class="classList"
    />
</template>
<script setup>
    import ProgressSpinner from 'primevue/progressspinner';
    import { defineProps, onMounted, ref, watch } from 'vue';

    const props = defineProps({
        class: {
            type: String,
            required: false,
            default: ''
        },
        fill: {
            type: String,
            required: false,
            default: 'transparent'
        }
    });

    const classList = ref();
    const fillColor = ref();
    onMounted(() => {
        classList.value = props.class;
        fillColor.value = props.fill;
    });

    watch(() => props.class, (newValue) => {
        classList.value = newValue;
    });

    watch(() => props.fill, (newValue) => {
        fillColor.value = newValue;
    });
</script>